import styled from "styled-components";
import { ColorsDomains } from "../../theme/styled";
import customMedia from "../../config/breakpoints";

export const Container = styled.div<{ color: string }>`

  justify-content:space-between;
  background: ${({ color, theme }) =>
    color
      ? theme.colors.domains[color as keyof ColorsDomains]
      : theme.colors.white}};
    box-sizing:border-box;
    display: flex;
    padding: 24px 32px;
    
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 60%;

  ${customMedia.lessThan("mobile")`
    width: 100%;
  `}
`;
export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 50px;
  justify-content: center;

  ${customMedia.lessThan("tablet")`
    margin-left: 10px
  `} ${customMedia.lessThan("mobile")`
    display:none;
  `};
`;
